import { render, staticRenderFns } from "./ManagementTable.vue?vue&type=template&id=5fb04ed6&"
import script from "./ManagementTable.vue?vue&type=script&lang=js&"
export * from "./ManagementTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports